module.exports = __webpack_public_path__ + "files/5d3aeb627e7c716b9e28c2e9e19383ff.png";